import React, { useEffect, useMemo, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useUser } from "../../context/UserContext";
import { Api } from "../../services/api";

export default function SpeakerDetail() {
  const { speakerId } = useParams();
  const navigate = useNavigate();
  const { user } = useUser();
  const api = useMemo(() => new Api(), []);
  const [speaker, setSpeaker] = useState(null);

  useEffect(() => {
    const getData = async () => {
      const response = await api.getWithAuth(
        `/api/speakers/${speakerId}`,
        user,
      );
      const json = await response.json();
      setSpeaker(json);
    };
    getData();
  }, [speakerId, user, api]);

  return (
    speaker && (
      <div className="col-span-full px-4 py-8">
        <div className="max-w-6xl mx-auto">
          <button
            onClick={() => navigate(-1)}
            className="text-blue-600 hover:underline mb-4"
          >
            ← Back
          </button>
          <div className="flex gap-6 mb-6">
            {speaker.mediaLink?.sizes?.profile?.url && (
              <img
                src={speaker.mediaLink.sizes.profile.url}
                alt={`${speaker.name} ${speaker.surname}`}
                className="w-24 h-24 rounded-full"
              />
            )}
            <div>
              <h1 className="text-3xl font-bold mb-2">
                {speaker.name} {speaker.surname}
              </h1>
              <p className="text-xl text-gray-600">
                {speaker.role} at {speaker.company}
              </p>
            </div>
          </div>
          {speaker.bio && (
            <div className="text-gray-700 mb-6">
              {speaker.bio[0]?.children[0]?.text}
            </div>
          )}
          {speaker.linkedinProfile && (
            <a
              href={speaker.linkedinProfile}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline"
            >
              LinkedIn Profile →
            </a>
          )}
        </div>
      </div>
    )
  );
}
